import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import router from './router';
import store from './store';
import axios from 'axios';

Vue.config.productionTip = false

axios.defaults.withCredentials = true
axios.defaults.params = {
    t: new Date().getTime()
}
axios.interceptors.request.use(function (config) {
    config.headers.common.authorization = JSON.stringify({ user: store.getters.StateUser, token: store.getters.StateToken });
    return config;
}, undefined)
axios.interceptors.response.use(undefined, function (error) {
    if (error) {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            store.dispatch('LogOut');
            router.push('/login')
        }
    }
    return Promise.reject(error)
})

if (process.env.NODE_ENV == 'development') {
    axios.defaults.baseURL = `http://${process.env.VUE_APP_IP}:8080/`;
}

Vue.use(VueTelInputVuetify, {
    vuetify
});

new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
